import { Apollo } from 'src/gql/generated';

/**
 * Subscribe to DocumentRelationship updates. Apollo auto-normalizes the
 * returned DocumentRelationship into the cache, so the watchQuery in
 * useReportDataSource (and any other cache observer) reacts automatically.
 *
 * Mount this once per top-level route that displays relationships:
 *   - Report / RepositoryAllDocuments (DataGrid + optional summary drawer).
 *   - Editor (summary drawer in right panel).
 */
export function useDocumentRelationshipSubscription(): void {
  Apollo.useOnDocumentRelationshipUpdatedSubscription({
    ignoreResults: true,
    shouldResubscribe: true,
  });
}
